.rail {
  /* Integrator (header chrome / editor gutter) overrides positioning + size
     via className. */
}

.list {
  list-style: none;
  margin: 0;
  padding: var(--tuna-spacing-0_5, 4px);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--tuna-spacing-0_5, 4px);
}

.list > li {
  display: flex;
}

@media (max-width: 899.95px) {
  /* Per Joni's mobile decision: rail collapses to a horizontal chip row
     under the title. */
  .list {
    flex-direction: row;
    gap: var(--tuna-spacing-1, 8px);
    padding: var(--tuna-spacing-0_5, 4px) var(--tuna-spacing-1, 8px);
  }
}
